<template>
  <div
    class="px-5 relative overflow-x-hidden overflow-y-scroll h-full"
    id="webContent"
  >
    <div
      v-for="category of filteredCategories"
      :key="`container-${category._id}`"
      class="w-[95%] md:w-[90%] mx-auto pt-2 md:pt-5 mb-6 products-container"
      :id="category._id"
    >
      <h2 :class="`w-full ${categoryHeaderClass}`">
        {{ category.name }}
      </h2>
      <div class="w-full my-3 border-2 border-b-secondary"></div>
      <div :class="`w-full grid grid-cols-1 gap-4 md:${gridColsClass}`">
        <router-link
          :to="`/products/${product._id}`"
          :id="product._id"
          v-for="product of category.products"
          :key="product._id"
        >
          <ProductCard :product="product" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useCategoryStore } from "@/app-store/category";
import ProductCard from "@/components/Menu/ProductCard";
import { PLATFORM } from "@/utils/constants";
import { useAppStore } from "@/app-store/app";
import { isCategoryAvailable } from "@/utils/General";

export default {
  name: "ProductsList",
  components: { ProductCard },
  data: () => ({
    platform: PLATFORM,
  }),
  computed: {
    ...mapWritableState(useCategoryStore, ["categories"]),
    ...mapState(useAppStore, ["layoutConfig"]),
    filteredCategories() {
      return this.categories.filter(isCategoryAvailable);
    },
    categoryHeaderClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.menu)
        return "text-color-first font-first text-base";
      return `text-color-${layoutConfig.menu.categoryHeaderTextColor} font-${layoutConfig.menu.categoryHeaderFont} text-xl md:text-${layoutConfig.menu.categoryHeaderTextSize}`;
    },
    gridColsClass() {
      const { layoutConfig } = this;
      if (
        !layoutConfig ||
        !layoutConfig.menu ||
        !layoutConfig.menu.productsColumns
      )
        return "grid-cols-3";
      return `grid-cols-${layoutConfig.menu.productsColumns}`;
    },
  },
  mounted() {
    if (
      this.$route.query &&
      this.$route.query.productId &&
      document.getElementById(this.$route.query.productId)
    ) {
      document.getElementById("webContent").scrollTo({
        top:
          document.getElementById(this.$route.query.productId).offsetTop - 140,
        behavior: "auto",
      });
    }
  },
};
</script>

<style scoped></style>
